export interface GuardrailControlReference {
  framework: string;
  controls: Array<{ id: string; href: string }>;
}

export interface GuardrailCatalogEntry {
  displayName: string;
  description: string;
  catalogId: string;
  controls: GuardrailControlReference[];
}

const IAM_ACCESS_KEY_CONTROL_URL = 'https://docs.aws.amazon.com/securityhub/latest/userguide/iam-controls.html#iam-3';
const ALB_WAF_CONTROL_URL = 'https://docs.aws.amazon.com/securityhub/latest/userguide/elb-controls.html#elb-16';
const PCI_DSS_V4_URL = '/api/documents/pci-dss-v4_0_1';
const NIST_AC_2_1_URL = 'https://csrc.nist.gov/projects/cprt/catalog#/cprt/framework/version/SP_800_53_5_2_0/control/AC-2(1)';
const NIST_AC_2_3_URL = 'https://csrc.nist.gov/projects/cprt/catalog#/cprt/framework/version/SP_800_53_5_2_0/control/AC-2(3)';
const NIST_AC_3_15_URL = 'https://csrc.nist.gov/projects/cprt/catalog#/cprt/framework/version/SP_800_53_5_2_0/control/AC-3(15)';

export const GUARDRAIL_CATALOG: Record<string, GuardrailCatalogEntry> = {
  'iam-accesskeys': {
    displayName: 'Expira\u00e7\u00e3o de AWS IAM User Access Keys',
    description: 'Desativa AWS IAM Users Access Keys com idade superior a 100 dias por agendamento (de segunda a quinta-feira, \u00e0s 09h01 no hor\u00e1rio de Bras\u00edlia, 12h01 UTC) ou por remedia\u00e7\u00e3o autom\u00e1tica quando chaves j\u00e1 desabilitadas forem reabilitadas. Cadastre exce\u00e7\u00f5es com data limite abaixo para casos excepcionais.',
    catalogId: 'AWS-REM-T0-002',
    controls: [
      { framework: 'FSBP', controls: [{ id: 'IAM.3', href: IAM_ACCESS_KEY_CONTROL_URL }] },
      {
        framework: 'PCI DSS v4.0.1',
        controls: [
          { id: '8.3.9', href: PCI_DSS_V4_URL },
          { id: '8.6.3', href: PCI_DSS_V4_URL },
        ],
      },
      {
        framework: 'NIST SP 800-53 Rev. 5',
        controls: [
          { id: 'AC-2(1)', href: NIST_AC_2_1_URL },
          { id: 'AC-2(3)', href: NIST_AC_2_3_URL },
          { id: 'AC-3(15)', href: NIST_AC_3_15_URL },
        ],
      },
    ],
  },
  'alb-waf': {
    displayName: 'Enforcement de AWS WAF WebACLs em Application Load Balancers.',
    description: 'Garante a configura\u00e7\u00e3o de AWS WAF WebACLs em Application Load Balancers, aplicando, por remedia\u00e7\u00e3o autom\u00e1tica, tags cadastradas no Firewall Manager com as pol\u00edticas corporativas de prote\u00e7\u00e3o. Para permitir que novas pol\u00edticas de WAF sejam utilizadas, crie a policy no Firewall Manager, defina a tag e cadastre o valor na lista abaixo.',
    catalogId: 'AWS-REM-T2-001',
    controls: [
      { framework: 'FSBP', controls: [{ id: 'ELB.16', href: ALB_WAF_CONTROL_URL }] },
      { framework: 'PCI DSS v4.0.1', controls: [{ id: '6.4.2', href: PCI_DSS_V4_URL }] },
      { framework: 'NIST SP 800-53 Rev. 5', controls: [{ id: 'AC-4(21)', href: ALB_WAF_CONTROL_URL }] },
    ],
  },
};

export function getGuardrailCatalogId(guardrail?: string, emittedId?: string): string | undefined {
  return emittedId?.trim() || (guardrail ? GUARDRAIL_CATALOG[guardrail]?.catalogId : undefined);
}